import Navbar from '../components/navbar';
import ReviewHighlight from '../components/homepage/reviewHighlight';
import AboutMERL from '../components/homepage/aboutMERL';
import Footer from '../components/footer';
import '../App.scss';

const Home = () => {

	document.title = "MERL — Media Education Research Lab";
    return (
		<div className="App">
			<header>
				<Navbar></Navbar>
			</header>
		  
			<body>
				{/* <TopStudios/> */}
				<AboutMERL/>
				<ReviewHighlight
					titles={"When They See Us, Captain Marvel, Fleabag-s2, Joker"}
					sectionName={"Featured Reviews"}/>
				<div className='white' >
					<br/><br/><br/>	
				</div>
				<ReviewHighlight
					titles={"Turning Red, Past Lives"}
					sectionName={"Special Collection: AAPI Film and TV"}
					  linkText={"See All AAPI Films and TV >>"}
					  linkTo={"/aapi"}/>
				<div className='white' >
					<br/><br/><br/>	
				</div>
				<ReviewHighlight
					titles={"WandaVision-s1, Pose-s2"}
					sectionName={"Special Collection: The Walt Disney Company"}
					  linkText={"See All Disney Films and TV >>"}
					  linkTo={"/waltdisneycompany"}/>
				<div className='white' >
					<br/><br/><br/>	
				</div>
				<ReviewHighlight
					titles={"Pose-s3, Hacks-s1, Shang-Chi and the Legend of the Ten Rings, Sex Education-s2"}
					sectionName={"Highest-Rated Media"}/>
				<div className='white' >
					<br/><br/><br/>	
				</div>
				<ReviewHighlight
						titles={"Toy Story 4, Venom: Let There Be Carnage, 1917, Normal People-s1"}
						sectionName={"Lowest-Rated Media"}/>
				{/* <Collections/> */}
				{/* <Articles/> */}
				
				<Footer/>
			</body>
		</div>
	  );
}

export default Home;
